import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isExternalUrl',
})
export class IsExternalUrlPipe implements PipeTransform {
  transform(url: string | null | undefined): boolean {
    if (!url) return false;

    // 1. Verificar si empieza con protocolos comunes (http, https, mailto, tel)
    // o si empieza con "//" (protocol-relative URL)
    if (/^(https?:\/\/|mailto:|tel:|\/\/)/i.test(url)) {
      return true;
    }

    // 2. Intentar validar mediante el constructor URL si tiene un formato de dominio (ej. google.com)
    // aunque no tenga protocolo explícito en el string
    try {
      // Si el match de regex original es necesario para casos tipo "www.google.com" sin protocolo:
      if (/^.*:\/\/.*\..*/.test(url)) return true;

      // Verificación adicional para detectar dominios que el regex podría omitir
      const parsed = new URL(url);
      return !!parsed.protocol;
    } catch {
      // Si falla el constructor URL, probablemente es una ruta interna (/dashboard)
      return false;
    }
  }
}
